export default __webpack_public_path__ + "static/media/wQ.878def39.svg";